/**
 * App State Slice
 * Manages application-wide state
 */

import create from 'zustand';
import type { AppState } from '../../types';

export const useAppStore = create<AppState>((set) => ({
  isYouTubeDataLatest: false,
  setIsYouTubeDataLatest: (value) => set({ isYouTubeDataLatest: value }),
}));

// Maintain backward compatibility
export default useAppStore;
